"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbossedModifier = exports.Embossed = void 0;
var Embossed;
(function (Embossed) {
    Embossed["Embossed"] = "u-embossed";
    Embossed["EmbossedDeep"] = "u-embossed-deep";
    Embossed["EmbossedShallow"] = "u-embossed-shallow";
    Embossed["EmbossedText"] = "u-embossed-text";
    Embossed["Raised"] = "u-raised";
    Embossed["RaisedDeep"] = "u-raised-deep";
    Embossed["RaisedShallow"] = "u-raised-shallow";
    Embossed["RaisedText"] = "u-raised-text";
    Embossed["Dropped"] = "u-dropped";
    Embossed["Lifted"] = "u-lifted";
    Embossed["Pillow"] = "u-pillow";
    Embossed["Ridge"] = "u-ridge";
})(Embossed = exports.Embossed || (exports.Embossed = {}));
var EmbossedModifier;
(function (EmbossedModifier) {
    EmbossedModifier["Hover"] = "@hover";
    EmbossedModifier["Pressed"] = "@pressed";
})(EmbossedModifier = exports.EmbossedModifier || (exports.EmbossedModifier = {}));
//# sourceMappingURL=Embossed.js.map